import { render, staticRenderFns } from "./taskKanban.vue?vue&type=template&id=3d6cd42c"
import script from "./taskKanban.vue?vue&type=script&lang=js"
export * from "./taskKanban.vue?vue&type=script&lang=js"
import style0 from "./taskKanban.vue?vue&type=style&index=0&id=3d6cd42c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports